var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ion",class:_vm.ionClass,attrs:{"data-title":_vm.iconTitle,"data-name":"md-play-icon"}},[_c('svg',{staticClass:"ion__svg",attrs:{"width":_vm.w,"height":_vm.h,"viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M96 52v408l320-204L96 52z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }